// ─── General-purpose formatters ──────────────────────────────────────────────
// Domain-agnostic helpers used across the platform (blogs, case studies, news,
// etc.). Do NOT import page-specific dependencies here.

/** Compact view/count formatter: 1,200 → "1.2K", 3,400,000 → "3.4M". */
export const formatViews = (count: number): string => {
    if (count >= 1_000_000) return `${(count / 1_000_000).toFixed(1)}M`;
    if (count >= 1_000) return `${(count / 1_000).toFixed(1)}K`;
    return String(count);
};

/**
 * Avatar initials from a display name.
 * "Jane Doe" → "JD", "Jane" → "J", "" → "?".
 */
export const getInitials = (name: string): string => {
    const parts = (name || '').trim().split(/\s+/);
    if (parts.length === 0 || !parts[0]) return '?';
    return parts.length === 1 ? parts[0][0].toUpperCase() : (parts[0][0] + (parts.at(-1)?.[0] ?? '')).toUpperCase();
};
